/** Only the inventory tab determines tour context; group/session filters do not. */
export function tourLocation(path: string, search = ''): string {
  const [pathname, query = ''] = path.split('?');
  if (pathname !== '/inventory') return pathname;
  const tab = new URLSearchParams(search || query).get('tab');
  return `${pathname}?tab=${tab === 'variance' || tab === 'history' ? tab : 'review'}`;
}

/** Ordinary step routes ignore query filters; an explicit tab must also match. */
export function matchesTourRoute(actual: string, expected: string): boolean {
  return expected.includes('?') ? tourLocation(actual) === tourLocation(expected)
    : actual.split('?')[0] === expected;
}
